const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const withPublicUrl = (assetPath = "") => {
  if (!assetPath) return "";
  if (/^(?:[a-z]+:)?\/\//i.test(assetPath)) return assetPath;
  if (!assetPath.startsWith("/")) return assetPath;
  return PUBLIC_URL ? `${PUBLIC_URL}${assetPath}` : assetPath;
};
